<template>
  <div>
    <PageAllow controller="PositionMoves" action="view" />
    <Breadcrumbs :items="items" />
    <ValidationObserver ref="observer">
      <v-sheet class="transparent-background-color pa-4">
        <!-- 选择商品 -->
        <div v-if="!created && !preview">
          <v-row dense align="center" class="px-4">
            <v-col cols="12" sm="12" md="4">
              <v-row dense align="center" class="pa-1">
                <SearcherStock
                  v-if="!preview"
                  v-model="stockSelected"
                  single-line
                  dense
                  hide-details
                  class="d-inline mt-0 mb-n1"
                  unclearable
                  :stockTypes="[0]"
                  :wmsSetting="[1]"
                />
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="8" align-self="center">
              <v-row dense align="center">
                <v-spacer />
                <v-btn
                  v-if="
                    !created &&
                    !preview &&
                    $permission.permissionAllow('PositionMoves', 'add')
                  "
                  small
                  color="primary"
                  class="ms-1"
                  @click.stop="getPositionReplenishMoveFromAPI()"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("MovePositionOrder.moveWay.auto_move_order") }}
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense align="center" class="px-4">
            <v-col cols="12" sm="6" md="4">
              <SearcherStockArea
                v-model="stockAreasSelected"
                :stock-id="stock_id"
                :disabled="!stockAreaSetting"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <SearcherStockRoadways
                v-model="stockRoadwaysSelected"
                :stock-id="stock_id"
                :disabled="!stockRoadwaysDisabled"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <SearcherStockPositions
                v-model="stockPositionsSelected"
                :stock-id="stock_id"
                :disabled="!stockPositionsDisabled"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="materialKeyword = $event"
                :label="$t('Stockouts.seacherMaterialKeyword')"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <SearcherMaterialCategory v-model="categorySelected" />
            </v-col>
          </v-row>

          <v-data-table
            v-if="!created && !preview"
            v-model="showSelected"
            :headers="replenishHeaders"
            class="elevation-2 pa-4"
            :items="positionReplenishList"
            show-select
            item-key="material_id"
            disable-sort
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :footer-props="$t('$config.footer-props')"
          >
          </v-data-table>
        </div>

        <!-- 创建编辑自动移库单 -->
        <div v-if="created">
          <v-expansion-panels v-model="panels" multiple accordion>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-card-title class="ms-n4 py-0">
                  {{
                    $t("CRUD.info", [
                      $t("MovePositionOrder.autoMovePositionOrder"),
                    ])
                  }}
                  <v-spacer />
                  <v-sheet
                    class="pt-1 transparent-background-color d-inline-block"
                  >
                    <v-btn
                      v-if="preview"
                      small
                      dark
                      outlined
                      color="secondary"
                      class="px-2 me-2 mb-1 elevation-1"
                      @click.stop="preview = false"
                    >
                      <v-icon x-small class="pe-1">fa-times</v-icon>
                      {{ $t("CRUD.backForModify") }}
                    </v-btn>
                    <v-btn
                      v-if="$permission.permissionAllow('PositionMoves', 'add')"
                      small
                      dark
                      color="primary"
                      class="px-2 me-2 mb-1"
                      @click.stop="preview ? doSubmit() : doPreview()"
                    >
                      <v-icon x-small class="pe-1">fa-save</v-icon>
                      {{
                        $t("MovePositionOrder.actions.submitMovePositionOrder")
                      }}
                    </v-btn>
                  </v-sheet>
                </v-card-title>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-divider />
                <v-row no-gutters class="mt-4 table-style">
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                      <span class="secondary--text">
                        {{ $t("MovePositionOrder.DetailFields.stock_name")
                        }}{{ $t("Global.colon") }}
                      </span>
                      {{ stockSelected ? stockSelected.name : "" }}
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                      <span class="secondary--text">
                        {{ $t("MovePositionOrder.DetailFields.operater_name")
                        }}{{ $t("Global.colon") }}
                      </span>
                      <SearcherAccountUser
                        v-if="!preview"
                        noLabel
                        :type="[1, 2]"
                        v-model="operateUser"
                        single-line
                        dense
                        hide-details
                        class="d-inline mt-0 mb-n1"
                      />
                      <span v-else>
                        {{ operateUser ? operateUser.name : "" }}
                      </span>
                    </v-card>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-card class="px-4 mt-4">
            <v-data-table
              v-if="!preview"
              :headers="createdHeaders"
              :items="positionReplenishMoveList"
              :search="savableFilter"
              multi-sort
              disable-pagination
              hide-default-footer
              :no-data-text="$t('MovePositionOrder.DetailNoData')"
              class="py-5"
              group-by="material_id"
            >
              <template v-slot:top>
                <v-toolbar flat class="transparent-background-color">
                  <v-toolbar-title class="ms-n2">
                    {{
                      $t("CRUD.details", [$t("MovePositionOrder.ObjectName")])
                    }}
                  </v-toolbar-title>
                  <v-spacer />
                  <v-btn
                    v-if="stock_id"
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click="addAutoMovePositionDetails()"
                  >
                    {{
                      $t("MovePositionOrder.actions.autoMovePositionOrderBtn")
                    }}
                  </v-btn>
                </v-toolbar>
                <v-divider />
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        positionReplenishMoveList
                          ? [
                              1,
                              positionReplenishMoveList.length,
                              positionReplenishMoveList.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-spacer />
                  <v-row no-gutters class="me-n3">
                    <v-spacer />
                    <v-col cols="12" sm="9" md="8">
                      <v-text-field
                        v-model="savableFilter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:header.actions="{ header }">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </template>
              <template v-slot:group.header="{ isOpen, toggle, group, items }">
                <td :colspan="createdHeaders.length - 3">
                  {{ items[0].material_description }}
                </td>
                <td>
                  {{
                    $t("MovePositionOrder.DetailFields.material_category") +
                    $t("Global.colon")
                  }}{{ items[0].category_name }}
                </td>
                <td>
                  {{
                    $t("MovePositionOrder.DetailFields.auto_move_num") +
                    $t("Global.colon")
                  }}{{ items[0].replenish_stock_unit_num }}
                </td>
                <td align="center" @click="toggle">
                  <v-icon class="pe-1" size="30px" v-if="!isOpen"
                    >fa-angle-down</v-icon
                  >
                  <v-icon class="pe-1" size="30px" v-else>fa-angle-up</v-icon>
                </td>
              </template>
              <template v-slot:group.summary="{ items }">
                <td :colspan="createdHeaders.length">
                  <SearcherMovePosition
                    v-model="items[0].addMovePositionTo"
                    :stock="stockSelected"
                    :stockPositions="items[0].from_positions"
                    @changed="stockBatchSelect(items[0], $event)"
                  />
                </td>
              </template>
              <template v-slot:item.position_name="{ item }">
                <span class="text-no-wrap caption font-weight-bold">
                  {{
                    item.move_position_from
                      ? item.move_position_from.Description
                      : ""
                  }}
                </span>
                <br />
                <span
                  class="text-no-wrap caption secondary--text"
                  :class="
                    $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                  "
                >
                  {{
                    item.move_position_from.stock_position_label
                      ? item.move_position_from.stock_position_label.label_name
                      : ""
                  }}
                </span>
              </template>
              <template v-slot:item.stock_batch_code="{ item }">
                {{
                  item.stock_detail ? item.stock_detail.stock_batch_code : ""
                }}
              </template>
              <template v-slot:item.stock_position_batch_num="{ item }">
                <span v-if="item.new">
                  {{
                    item.stock_rate > 1
                      ? item.stock_position_batch_num_rate
                      : item.stock_position_batch_num_default
                  }}
                </span>
              </template>
              <template v-slot:item.move_position_to="{ item }">
                <!-- 本页面获取库位 -->
                <ValidationProvider
                  v-if="item.new"
                  v-slot="{ errors }"
                  rules="trequired"
                >
                  <v-autocomplete
                    v-model="item.move_position_to"
                    :items="disabledPosition(item)"
                    :loading="stockPositionLoading"
                    :search-input.sync="item.stockPositionSearch"
                    item-value="id"
                    item-text="position_description"
                    item-disabled="disabled"
                    :label="
                      $t('MovePositionOrder.DetailFields.move_position_in')
                    "
                    return-object
                    clearable
                    :error-messages="errors"
                  >
                  </v-autocomplete>
                </ValidationProvider>
              </template>
              <template v-slot:item.move_num="{ item }">
                <span v-if="item.new && item.stock_rate > 1">
                  <div class="d-inline-block">
                    <NumberInput v-model="item.move_num_rate" dense>
                      <template v-slot:append>
                        {{ item.stock_unit }}
                      </template>
                    </NumberInput>
                  </div>
                  <div class="d-inline-block">
                    <NumberInput v-model="item.move_num_default" dense>
                      <template v-slot:append>
                        {{ item.default_unit }}
                      </template>
                    </NumberInput>
                  </div>
                </span>
                <span v-else-if="item.new">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :rules="{
                      max_value: { max: item.position_num },
                    }"
                  >
                    <NumberInput
                      v-model="item.move_num_default"
                      :error-messages="errors"
                      dense
                    >
                      <template v-slot:append>
                        {{ item.default_unit }}
                      </template>
                    </NumberInput>
                  </ValidationProvider>
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="item.new"
                  small
                  text
                  class="danger--text pa-0"
                  @click.stop="removeItem(item)"
                >
                  <v-icon>fa-times</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <v-data-table
              v-if="created && preview"
              :headers="detailsHeaders"
              :items="moveOrderDetailItems"
              multi-sort
              disable-pagination
              hide-default-footer
              :no-data-text="$t('MovePositionOrder.DetailNoData')"
              class="py-5"
            >
              <template v-slot:top>
                <v-toolbar flat class="transparent-background-color">
                  <v-toolbar-title class="ms-n2">
                    {{
                      $t("CRUD.details", [$t("MovePositionOrder.ObjectName")])
                    }}
                  </v-toolbar-title>
                </v-toolbar>
                <v-divider />
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        moveOrderDetailItems
                          ? [
                              1,
                              moveOrderDetailItems.length,
                              moveOrderDetailItems.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-spacer />
                </v-toolbar>
              </template>
              <template v-slot:item.move_position_out="{ item }">
                <span class="text-no-wrap caption font-weight-bold">
                  {{ item.position_from.position_from_description }}
                </span>
                <br />
                <span
                  class="text-no-wrap caption secondary--text"
                  :class="
                    $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                  "
                >
                  {{
                    item.position_from.stock_position_label
                      ? item.position_from.stock_position_label.label_name
                      : item.position_from.label_name
                      ? item.position_from.label_name
                      : ""
                  }}
                </span>
              </template>
              <template v-slot:item.move_position_in="{ item }">
                <span class="text-no-wrap caption font-weight-bold">
                  {{ item.position_to.position_to_description }}
                </span>
                <br />
                <span
                  class="text-no-wrap caption secondary--text"
                  :class="
                    $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                  "
                >
                  {{
                    item.position_to.stock_position_label
                      ? item.position_to.stock_position_label.label_name
                      : item.position_to.label_name
                      ? item.position_to.label_name
                      : ""
                  }}
                </span>
              </template>
              <template v-slot:item.move_num="{ item }">
                {{ item.move_num | formatTwoDot }}
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-sheet>
    </ValidationObserver>

    <SelectStockBatchDialog
      v-model="stockBatchDialog"
      :stockBatch="stockPositionBatchs"
      @stockBatchSeleted="stockBatchSelectedDetail = $event"
    />

    <v-dialog v-model="errorMoveDialog" width="850px">
      <v-card>
        <v-card-title>
          <span class="headline" center>
            {{ $t("$vuetify.warning") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="errorMoveDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Wave.PickingFields.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <h3>
              {{
                $t("MovePositionOrder.errorMoveNumCountTitle") +
                $t("Global.colon")
              }}
            </h3>
            <v-list disabled>
              <v-list-item-group v-model="errorMoveList" color="primary">
                <v-list-item v-for="(item, i) in errorMoveList" :key="i">
                  <v-list-item-content>
                    <v-list-item-title class="subtitle-2 ml-4">
                      {{
                        $t("MovePositionOrder.errorMoveListItem", [
                          item.position_code
                            ? item.position_code
                            : item.move_position_to
                            ? item.move_position_to.position_code
                            : "",
                          item.position_name
                            ? item.position_name
                            : item.move_position_to
                            ? item.move_position_to.position_name
                            : "",
                          item.material_description,
                          item.stock_batch_code
                            ? item.stock_batch_code
                            : item.stock_detail
                            ? item.stock_detail.stock_batch_code
                            : "",
                        ])
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="errorMoveDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.v-data-table .v-row-group__summary {
  background: transparent !important;
}
</style>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherStockArea from "@/components/plugins/SearcherStockArea";
import SearcherStockPositions from "@/components/plugins/SearcherStockPositions";
import SearcherStockRoadways from "@/components/plugins/SearcherStockRoadways";
import NumberInput from "@/components/plugins/NumberInput";
import SearcherMovePosition from "./plugins/SearcherMovePosition";
import SelectStockBatchDialog from "./plugins/SelectStockBatchDialog";
import MovePositionOrders from "@/api/move_position_orders";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationObserver,
    ValidationProvider,
    SearcherStock,
    SearcherAccountUser,
    SearcherKeyword,
    SearcherMaterialCategory,
    SearcherStockArea,
    SearcherStockPositions,
    SearcherStockRoadways,
    NumberInput,
    SearcherMovePosition,
    SelectStockBatchDialog,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.movePositionOrder"),
          disabled: false,
          href: "/move-position-order",
        },
        {
          text: i18n.t("Nav.movePositionOrderDetail"),
          disabled: true,
        },
      ];
      return items;
    },
    stock_id() {
      return this.stockSelected ? this.stockSelected.id : 0;
    },
    replenishHeaders() {
      return [
        {
          text: i18n.t(
            "MovePositionOrder.AutoMoveDetailFields.material_category"
          ),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("MovePositionOrder.AutoMoveDetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("MovePositionOrder.AutoMoveDetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t(
            "MovePositionOrder.AutoMoveDetailFields.reference_move_num"
          ),
          align: "start",
          value: "stock_unit_replenish_num",
        },
      ];
    },
    createdHeaders() {
      var headers = [
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_position_out"),
          align: "center",
          value: "position_name",
          sortable: false,
          groupable: false,
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.stock_batch_code"),
          align: "center",
          value: "stock_batch_code",
          sortable: false,
          groupable: false,
        },
        {
          text: i18n.t(
            "MovePositionOrder.DetailFields.stock_position_batch_num"
          ),
          align: "center",
          value: "stock_position_batch_num",
          sortable: false,
          groupable: false,
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_position_in"),
          align: "center",
          value: "move_position_to",
          sortable: false,
          groupable: false,
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_num"),
          align: "center",
          value: "move_num",
          sortable: false,
          groupable: false,
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          value: "actions",
          sortable: false,
          groupable: false,
        },
      ];

      return headers;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("MovePositionOrder.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.material"),
          align: "center",
          value: "Description",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_position_out"),
          align: "center",
          value: "move_position_out",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.stock_batch_code"),
          align: "center",
          value: "stock_detail.stock_batch_code",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_position_in"),
          align: "center",
          value: "move_position_in",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_num"),
          align: "end",
          value: "move_num",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.unit"),
          align: "end",
          value: "unit",
        },
      ];

      return headers;
    },

    positionReplenishMoveItems() {
      return this.positionReplenishMoveLis.map((detail) => {
        // detail.Description = i18n.t(
        //   this.settings
        //     ? this.settings.material_name_display_type == 3
        //       ? "Material.materialNameWithCodeAndStandard"
        //       : this.settings.material_name_display_type == 2
        //       ? "Material.materialNameWithCode"
        //       : "Material.materialName"
        //     : "Material.materialName",
        //   [detail.material_code, detail.material_name, detail.standard_name]
        // );

        //格式化库位名称
        var position_from_description = i18n.t(
          "MovePositionOrder.DetailFields.position",
          [
            detail.position_from.position_code,
            detail.position_from.position_name,
          ]
        );
        if (
          this.moveOrder.stock &&
          this.moveOrder.stock.position_name_display
        ) {
          if (this.moveOrder.stock.position_name_display.indexOf(2) > -1) {
            position_from_description = detail.position_from.position_name;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(4) > -1 &&
            detail.position_from.roadway_code
          ) {
            position_from_description =
              detail.position_from.roadway_code +
              " - " +
              position_from_description;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(3) > -1 &&
            detail.position_from.area_name
          ) {
            position_from_description =
              detail.position_from.area_name +
              " - " +
              position_from_description;
          }
        }
        detail.position_from.position_from_description =
          position_from_description;

        //格式化库位名称
        var position_to_description = i18n.t(
          "MovePositionOrder.DetailFields.position",
          [detail.position_to.position_code, detail.position_to.position_name]
        );
        if (
          this.moveOrder.stock &&
          this.moveOrder.stock.position_name_display
        ) {
          if (this.moveOrder.stock.position_name_display.indexOf(2) > -1) {
            position_to_description = detail.position_to.position_name;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(4) > -1 &&
            detail.position_to.roadway_code
          ) {
            position_to_description =
              detail.position_to.roadway_code + " - " + position_to_description;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(3) > -1 &&
            detail.position_to.area_name
          ) {
            position_to_description =
              detail.position_to.area_name + " - " + position_to_description;
          }
        }
        detail.position_to.position_to_description = position_to_description;

        return detail;
      });
    },
    moveOrderDetailItems() {
      return this.moveOrderDetails.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );

        //格式化库位名称
        var position_from_description = i18n.t(
          "MovePositionOrder.DetailFields.position",
          [
            detail.position_from.position_code,
            detail.position_from.position_name,
          ]
        );
        if (
          this.moveOrder.stock &&
          this.moveOrder.stock.position_name_display
        ) {
          if (this.moveOrder.stock.position_name_display.indexOf(2) > -1) {
            position_from_description = detail.position_from.position_name;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(4) > -1 &&
            detail.position_from.roadway_code
          ) {
            position_from_description =
              detail.position_from.roadway_code +
              " - " +
              position_from_description;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(3) > -1 &&
            detail.position_from.area_name
          ) {
            position_from_description =
              detail.position_from.area_name +
              " - " +
              position_from_description;
          }
        }
        detail.position_from.position_from_description =
          position_from_description;

        //格式化库位名称
        var position_to_description = i18n.t(
          "MovePositionOrder.DetailFields.position",
          [detail.position_to.position_code, detail.position_to.position_name]
        );
        if (
          this.moveOrder.stock &&
          this.moveOrder.stock.position_name_display
        ) {
          if (this.moveOrder.stock.position_name_display.indexOf(2) > -1) {
            position_to_description = detail.position_to.position_name;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(4) > -1 &&
            detail.position_to.roadway_code
          ) {
            position_to_description =
              detail.position_to.roadway_code + " - " + position_to_description;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(3) > -1 &&
            detail.position_to.area_name
          ) {
            position_to_description =
              detail.position_to.area_name + " - " + position_to_description;
          }
        }
        detail.position_to.position_to_description = position_to_description;

        return detail;
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },

  data: () => ({
    panels: [0],
    created: false,
    preview: false,
    stockSelected: null,
    operateUser: null,
    showSelected: [],
    materialKeyword: "",
    categorySelected: null,
    stockAreaSetting: false,
    stockAreasSelected: null,
    stockPositionsDisabled: false,
    stockPositionsSelected: null,
    stockRoadwaysDisabled: false,
    stockRoadwaysSelected: null,
    options: { keyword: "", category_id: 0, stock_area_id: 0 },
    positionReplenishList: [],
    paging: {},
    stockPositionLoading: false,
    positionReplenishMoveList: [],
    oldPositionReplenishMoveList: [],
    savableFilter: "",
    currentItem: null,
    stockBatchDialog: false,
    stockPositionBatchs: [],
    stockBatchSelectedDetail: [],
    errorMoveDialog: false,
    errorMoveList: [],
    moveOrder: {},
    moveOrderDetails: [],
  }),

  methods: {
    //获取补货一览
    getPositionReplenishFromAPI() {
      MovePositionOrders.autoPositionReplenishList(
        Object.assign({}, this.options, {
          stock_id: this.stock_id,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.positionReplenishList = response.data.materials;
          }
        }.bind(this)
      );
    },
    //获取新建自动移库单详情
    getPositionReplenishMoveFromAPI() {
      var materialIds = this.showSelected.map((selected) => {
        return selected.material_id;
      });
      if (materialIds.length) {
        this.created = true;
        MovePositionOrders.autoPositionReplenishMoveList({
          stock_id: this.stock_id,
          material_ids: materialIds,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              var materialList = response.data.auto_move_material_list;
              for (var key in materialList) {
                //商品名称跟随设置
                materialList[key].material_description = i18n.t(
                  this.settings
                    ? this.settings.material_name_display_type == 4
                      ? "Material.nameWithCodeAndStandard"
                      : this.settings.material_name_display_type == 3
                      ? "Material.materialNameWithCodeAndStandard"
                      : this.settings.material_name_display_type == 2
                      ? "Material.materialNameWithCode"
                      : "Material.materialName"
                    : "Material.materialName",
                  [
                    materialList[key].material_code,
                    materialList[key].material_name,
                    materialList[key].standard_name,
                  ]
                );
                //库位名称
                materialList[key].from_positions.forEach((position) => {
                  position.position_description =
                    this.formatePositionName(position);
                });
                materialList[key].to_positions.forEach((position) => {
                  position.position_description =
                    this.formatePositionName(position);
                });

                //自动移库基本商品信息
                materialList[key].addMovePositionTo = {};
                materialList[key].move_position_from = {};
                materialList[key].move_position_to = {};

                this.positionReplenishMoveList.push(materialList[key]);
              }
              this.oldPositionReplenishMoveList = JSON.parse(
                JSON.stringify(materialList)
              );
            }
          }.bind(this)
        );
      }
    },
    //格式化库位名称
    formatePositionName(position) {
      var position_description = i18n.t(
        "MovePositionOrder.DetailFields.position",
        [position.position_code, position.position_name]
      );
      if (this.stockSelected && this.stockSelected.position_name_display) {
        if (this.stockSelected.position_name_display.indexOf(2) > -1) {
          position_description = position.position_name;
        }
        if (
          this.stockSelected.position_name_display.indexOf(4) > -1 &&
          position.roadway_code
        ) {
          position_description =
            position.roadway_code + " - " + position_description;
        }
        if (
          this.stockSelected.position_name_display.indexOf(3) > -1 &&
          position.area_name
        ) {
          position_description =
            position.area_name + " - " + position_description;
        }
      }

      return position_description;
    },
    //库位select禁选项
    disabledPosition(batch_detail) {
      //判断当前明细的禁选库位
      if (batch_detail.to_positions)
        var position = batch_detail.to_positions.find(
          (position) =>
            position.id == batch_detail.move_position_from.id &&
            !position.disabled
        );
      if (position) {
        position.disabled = true;
      }

      this.positionReplenishMoveList.forEach((detail) => {
        if (
          detail.move_position_from &&
          batch_detail.move_position_from &&
          detail.move_position_from.id == batch_detail.move_position_from.id &&
          detail.move_position_to &&
          detail.move_position_to.id &&
          detail.stock_detail_id == batch_detail.stock_detail_id
        ) {
          var position = batch_detail.to_positions.find(
            (position) => position.id == detail.move_position_to.id
          );
          if (position) {
            position.disabled = true;
          }
        }
      });

      return batch_detail.to_positions;
    },
    //选择批次
    stockBatchSelect(materialDetail, positionSelected) {
      if (positionSelected) {
        this.stockBatchDialog = true;
        this.currentItem = JSON.parse(
          JSON.stringify(
            Object.assign({}, materialDetail, {
              addMovePositionTo: positionSelected,
            }) //防止数据更新延迟，直接赋值
          )
        );
        this.stockPositionBatchs = JSON.parse(
          JSON.stringify(
            materialDetail.stock_material_positions[positionSelected.id]
          )
        );

        this.stockPositionBatchs.forEach((batch) => {
          batch.material_description = materialDetail.material_description;
          batch.position_description = positionSelected.Description;
        });
      }
    },
    //移除部分库位批次或商品
    removeItem(data) {
      //自动移库
      var removeDetailKey = this.positionReplenishMoveList.findIndex(
        (detail) => detail.new == data.new
      );
      if (removeDetailKey > -1) {
        var unDelMaterialDetails = this.positionReplenishMoveList.filter(
          (move_detail) => move_detail.material_id == data.material_id
        );
        //判断这个商品的移库明细是否只剩下一条
        if (unDelMaterialDetails.length > 1) {
          this.positionReplenishMoveList.splice(removeDetailKey, 1);
        } else {
          //取原基本数据
          var updateData = JSON.parse(
            JSON.stringify(this.oldPositionReplenishMoveList[data.material_id])
          );
          updateData.move_position_from = {};
          updateData.move_position_to = {};
          //移除带有移库详情的明细，添加不带移库详情的原数据
          this.positionReplenishMoveList.splice(removeDetailKey, 1);
          this.positionReplenishMoveList.push(updateData);
        }
      }
    },
    //自动移库详情
    addAutoMovePositionDetails() {
      this.positionReplenishMoveList.forEach((moveItem) => {
        //计算当前商品已手动填写的移库数量
        var inputtedMoveNumCount = 0;
        this.positionReplenishMoveList.map((list) => {
          if (list.material_id == moveItem.material_id) {
            if (list.stock_rate > 1 && list.move_num_rate) {
              inputtedMoveNumCount += list.move_num_rate * list.stock_rate;
            }
            if (list.move_num_default) {
              inputtedMoveNumCount += Number(list.move_num_default);
            }
          }
        });
        //获取当前商品的库位批次信息
        var stockMaterialPositions =
          this.oldPositionReplenishMoveList[moveItem.material_id]
            .stock_material_positions;
        //获取当前商品推荐移库量
        var replenishNum =
          this.oldPositionReplenishMoveList[moveItem.material_id].replenish_num;
        //获取当前商品的移出库位列表
        var fromPositions =
          this.oldPositionReplenishMoveList[moveItem.material_id]
            .from_positions;

        //自动顺位新增
        for (var stockMaterialPositionKey in stockMaterialPositions) {
          var stockPositionBatchs =
            stockMaterialPositions[stockMaterialPositionKey];
          for (var stockPositionBatchKey in stockPositionBatchs) {
            var stockPositionBatch = stockPositionBatchs[stockPositionBatchKey];
            var copyBatchDetail = JSON.parse(
              JSON.stringify(stockPositionBatch)
            ); //深拷贝当前批次详情
            var newDetail = JSON.parse(JSON.stringify(moveItem)); //深拷贝当前商品库位批次详情
            newDetail.move_num_rate = 0; //初始化移库量
            newDetail.move_num_default = 0; //初始化移库量
            //当前库位批次已手动添加过
            var batchAddedArr = this.positionReplenishMoveList.filter(
              (moveDetail) =>
                moveDetail.stock_detail_id == stockPositionBatch.stock_detail.id
            );

            //判断当前自动添加的批次的移动量是否达到推荐移库量
            if (inputtedMoveNumCount < replenishNum) {
              newDetail.stock_material_position_id = copyBatchDetail.id;
              //判断当前批次数量是否满足推荐移库量;
              if (batchAddedArr.length) {
                var movedNumCount = 0; //已填写的移库量
                batchAddedArr.forEach((added) => {
                  if (added.move_num_rate) {
                    movedNumCount +=
                      Number(added.move_num_rate) * Number(added.stock_rate);
                  }
                  if (added.move_num_default) {
                    movedNumCount += Number(added.move_num_default);
                  }
                });
                //判断已填写的移库量
                if (movedNumCount < stockPositionBatch.position_num) {
                  if (
                    stockPositionBatch.position_num <
                    replenishNum - inputtedMoveNumCount
                  ) {
                    newDetail.move_num_default =
                      stockPositionBatch.position_num - movedNumCount;
                    newDetail.position_num = stockPositionBatch.position_num;
                    inputtedMoveNumCount += Number(newDetail.move_num_default);
                  } else {
                    newDetail.move_num_default =
                      replenishNum - inputtedMoveNumCount;
                    newDetail.position_num = stockPositionBatch.position_num;
                    inputtedMoveNumCount += Number(newDetail.move_num_default);
                  }
                } else {
                  return;
                }
              } else {
                if (
                  stockPositionBatch.position_num >
                  replenishNum - inputtedMoveNumCount
                ) {
                  newDetail.move_num_default =
                    replenishNum - inputtedMoveNumCount;
                  newDetail.position_num = stockPositionBatch.position_num;
                  inputtedMoveNumCount += Number(newDetail.move_num_default);
                } else if (
                  stockPositionBatch.position_num <
                    replenishNum - inputtedMoveNumCount ||
                  stockPositionBatch.position_num ==
                    replenishNum - inputtedMoveNumCount
                ) {
                  newDetail.move_num_default = copyBatchDetail.position_num;
                  newDetail.position_num = stockPositionBatch.position_num;
                  inputtedMoveNumCount += Number(newDetail.move_num_default);
                }
              }

              //去除与newDetail中重复的字段;
              this.$delete(copyBatchDetail, "id");
              // this.$delete(copyBatchDetail, "stock_num");

              //移出库位;
              // var move_position_from = fromPositions.find(
              //   (position) => position.id == copyBatchDetail.stock_position_id
              // );
              // newDetail.move_position_from = move_position_from;
              // newDetail.move_position_from.position_description = i18n.t(
              //   "MovePositionOrder.DetailFields.position",
              //   [
              //     move_position_from.position_code,
              //     move_position_from.position_name,
              //   ]
              // );
              fromPositions.find((position) => {
                if (position.id == copyBatchDetail.stock_position_id) {
                  position.Description = this.formatePositionName(position);
                  newDetail.move_position_from = position;
                }
              });

              //移入库位
              var positionsUsable = this.disabledPosition(newDetail);
              positionsUsable.some(
                function (position) {
                  if (!position.disabled) {
                    position.Description = this.formatePositionName(position);
                    newDetail.move_position_to = position;
                    return true;
                  }
                }.bind(this)
              );

              //单位转换
              if (newDetail.stock_rate > 1) {
                var batchNumRate = parseInt(
                  newDetail.position_num / newDetail.stock_rate
                );
                if (newDetail.position_num % newDetail.stock_rate) {
                  var batchNumDefault =
                    newDetail.position_num % newDetail.stock_rate;
                  newDetail.stock_position_batch_num_rate = i18n.t(
                    "MovePositionOrder.DetailFields.quantityWithMultipleUnits",
                    [
                      batchNumRate,
                      newDetail.stock_unit,
                      batchNumDefault,
                      newDetail.default_unit,
                    ]
                  );
                } else {
                  newDetail.stock_position_batch_num_rate = i18n.t(
                    "MovePositionOrder.DetailFields.quantityWithUnit",
                    [batchNumRate, newDetail.stock_unit]
                  );
                }
              } else {
                newDetail.stock_position_batch_num_default = i18n.t(
                  "MovePositionOrder.DetailFields.quantityWithUnit",
                  [newDetail.position_num, newDetail.default_unit]
                );
              }

              //追加移库明细
              var firstItemKey = this.positionReplenishMoveList.findIndex(
                (move_detail) =>
                  move_detail.material_id == moveItem.material_id &&
                  !move_detail.new
              );

              var addedDetails = this.positionReplenishMoveList.filter(
                (move_detail) => move_detail.new
              );
              if (!addedDetails.length) {
                newDetail.new = 1;
              } else {
                newDetail.new = addedDetails.length + 1;
              }

              if (firstItemKey > -1) {
                newDetail.addMovePositionTo = null;
                Object.assign(
                  this.positionReplenishMoveList[firstItemKey],
                  Object.assign(newDetail, copyBatchDetail)
                );
              } else {
                if (Object.hasOwnProperty.call(newDetail, "addMovePositionTo"))
                  this.$delete(newDetail, "addMovePositionTo");
                this.positionReplenishMoveList.push(
                  Object.assign(newDetail, copyBatchDetail)
                );
              }
            }
          }
        }
      });
    },
    //整理提交数据
    submitData() {
      var moveDetails = [];
      this.errorMoveList = []; //提交前清除错误移库列表，重新校验
      var editDetail = [];
      if (this.preview) {
        //预览
        this.moveOrderDetails.forEach((detail) => {
          moveDetails.push({
            material_code: detail.material_code,
            position_from_id: detail.position_from_id,
            position_to_id: detail.position_to_id,
            move_num: detail.move_num,
            stock_detail_id: detail.stock_detail_id,
          });
        });
      } else {
        this.positionReplenishMoveList.forEach((edit_move_detail) => {
          if (edit_move_detail.new) {
            editDetail.push(edit_move_detail);
          }
        });

        if (!editDetail.length) {
          this.$snackbar.error(
            i18n.t("MovePositionOrder.errorPreviewMoveDetailRequire")
          );
        } else {
          editDetail.forEach((detail) => {
            detail.move_num_count = 0;
            var batchMoveNumCount = 0; //某个库位批次的总移库量
            var positionNum = Number(detail.position_num);

            if (editDetail.length == 1) {
              if (detail.move_num_rate) {
                batchMoveNumCount += detail.move_num_rate * detail.stock_rate;
              }
              if (detail.move_num_default) {
                batchMoveNumCount += detail.move_num_default;
              }
              detail.move_num_count = batchMoveNumCount;

              if (Number(batchMoveNumCount) > positionNum) {
                this.errorMoveList.push(detail);
              }
            } else {
              //计算当前明细的总移库量
              if (detail.move_num_rate) {
                detail.move_num_count +=
                  detail.move_num_rate * detail.stock_rate;
              }
              if (detail.move_num_default) {
                detail.move_num_count += Number(detail.move_num_default);
              }
              //取相同批次详情
              var sameBatchs = editDetail.filter(
                (edit_detail) =>
                  edit_detail.material_id == detail.material_id &&
                  edit_detail.stock_detail_id == detail.stock_detail_id
              );
              var inErrorMoveList = this.errorMoveList.findIndex(
                (errorDetail) =>
                  errorDetail.stock_detail_id == detail.stock_detail_id
              );
              //计算批次的总移库量，校验编辑移库量是否超过库位批次数量
              sameBatchs.forEach((sameItem) => {
                if (sameItem.move_num_rate) {
                  batchMoveNumCount +=
                    sameItem.move_num_rate * sameItem.stock_rate;
                }
                if (sameItem.move_num_default) {
                  batchMoveNumCount += Number(sameItem.move_num_default);
                }
              });
              //相同库位批次(移入库位不同)的总移库量
              if (batchMoveNumCount > positionNum && inErrorMoveList == -1) {
                this.errorMoveList.push(detail);
              }
            }

            if (!this.errorMoveList.length) {
              moveDetails.push({
                material_code:
                  this.oldPositionReplenishMoveList[detail.material_id]
                    .material_code,
                position_from_id: detail.move_position_from.id
                  ? detail.move_position_from.id
                  : 0,
                position_to_id: detail.move_position_to.id
                  ? detail.move_position_to.id
                  : 0,
                move_num: detail.move_num_count,
                stock_detail_id: detail.stock_detail_id,
              });
            }
          });
        }
      }

      return moveDetails;
    },
    //提交预览
    doPreview() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var data = this.submitData();
            if (!this.errorMoveList.length && data.length) {
              MovePositionOrders.addPreview({
                type: 2,
                stock_id: this.stock_id,
                operate_user_id: this.operateUser ? this.operateUser.id : 0,
                move_details: data,
              })
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.preview = true;
                      this.moveOrder = response.data.move_order;
                      this.moveOrderDetails =
                        response.data.move_order.move_details;
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    //提交移库单
    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      var data = this.submitData();
      MovePositionOrders.addMovePositionOrder({
        type: this.moveOrder.type,
        stock_id: this.stock_id,
        operate_user_id: this.operateUser ? this.operateUser.id : 0,
        move_details: data,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/move-position-order");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    stockSelected: {
      deep: true,
      handler() {
        if (this.stockSelected && this.stockSelected.id) {
          //切换仓库后，重置搜索条件
          this.showSelected = [];
          this.materialKeyword = "";
          this.categorySelected = null;
          this.stockAreaSetting = false;
          this.stockAreasSelected = null;
          this.options = { keyword: "", category_id: 0, stock_area_id: 0 };
          this.stockAreaSetting =
            this.stockSelected.stock_area &&
            this.stockSelected.position_replenish_rule &&
            this.stockSelected.position_replenish_rule != 1
              ? true
              : false;
          this.stockPositionsDisabled =
            this.stockSelected.position_replenish_rule &&
            this.stockSelected.position_replenish_rule != 1
              ? true
              : false;
          this.stockRoadwaysDisabled =
            this.stockSelected.position_replenish_rule &&
            this.stockSelected.position_replenish_rule != 1
              ? true
              : false;
          //重新加载补货商品列表
          this.getPositionReplenishFromAPI();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        this.getPositionReplenishFromAPI();
      },
    },
    categorySelected: {
      deep: true,
      handler() {
        this.options.category_id = this.categorySelected
          ? this.categorySelected.id
          : "";
      },
    },
    stockAreasSelected: {
      deep: true,
      handler() {
        this.options.stock_area_id = this.stockAreasSelected
          ? this.stockAreasSelected.id
          : "";
      },
    },
    accountUser: {
      deep: true,
      handler() {
        this.operateUser = this.accountUser ? this.accountUser : null;
      },
    },
    stockBatchSelectedDetail: {
      handler() {
        if (this.stockBatchSelectedDetail) {
          this.stockBatchSelectedDetail.forEach((selectedDetail) => {
            var addDetail = JSON.parse(JSON.stringify(selectedDetail)); //深拷贝
            //防止添加相同批次信息时，报id重复的警告
            addDetail.stock_material_position_id = addDetail.id;
            this.$delete(addDetail, "id");
            //从原数据中获取详情字段
            addDetail.move_position_from = this.currentItem.addMovePositionTo;
            addDetail.default_unit = this.currentItem.default_unit;
            addDetail.stock_rate = this.currentItem.stock_rate;
            addDetail.stock_unit = this.currentItem.stock_unit;
            addDetail.to_positions = this.currentItem.to_positions.map(
              (position) => {
                this.$delete(position, "disabled");
                return position;
              }
            );
            //单位转换
            if (addDetail.stock_rate > 1) {
              var batchNumRate = parseInt(
                addDetail.position_num / addDetail.stock_rate
              );
              if (addDetail.position_num % addDetail.stock_rate) {
                var batchNumDefault =
                  addDetail.position_num % addDetail.stock_rate;
                addDetail.stock_position_batch_num_rate = i18n.t(
                  "MovePositionOrder.DetailFields.quantityWithMultipleUnits",
                  [
                    batchNumRate,
                    addDetail.stock_unit,
                    batchNumDefault,
                    addDetail.default_unit,
                  ]
                );
              } else {
                addDetail.stock_position_batch_num_rate = i18n.t(
                  "MovePositionOrder.DetailFields.quantityWithUnit",
                  [batchNumRate, addDetail.stock_unit]
                );
              }
            } else {
              addDetail.stock_position_batch_num_default = i18n.t(
                "MovePositionOrder.DetailFields.quantityWithUnit",
                [addDetail.position_num, addDetail.default_unit]
              );
            }

            var updateMoveDetailKey = this.positionReplenishMoveList.findIndex(
              (move_detail) =>
                move_detail.material_id == addDetail.material_id &&
                move_detail.addMovePositionTo &&
                !move_detail.new
            );
            var newDetails = this.positionReplenishMoveList.filter(
              (move_detail) => move_detail.new
            );
            if (!newDetails.length) {
              addDetail.new = 1;
            } else {
              addDetail.new = newDetails.length + 1;
            }

            //所选的批次详情加入到详情列表中
            if (updateMoveDetailKey > -1) {
              // addDetail.stock_position_batch_num =
              //   this.positionReplenishMoveList[
              //     updateMoveDetailKey
              //   ].stock_position_batch_num_default;

              Object.assign(
                this.positionReplenishMoveList[updateMoveDetailKey],
                addDetail
              );
            } else {
              this.positionReplenishMoveList.push(addDetail);
            }
          });

          // 清空编辑项的库位select
          var editDetail = this.positionReplenishMoveList.find(
            (edit_detail) =>
              edit_detail.material_id == this.currentItem.material_id &&
              Object.keys(edit_detail.addMovePositionTo).length
          );
          if (editDetail) {
            editDetail.addMovePositionTo = null;
          }
        }
      },
    },
    stockBatchDialog: {
      deep: true,
      handler() {
        if (!this.stockBatchDialog && !this.stockBatchSelectedDetail.length) {
          //未选择批次关闭弹窗后，清除库位下拉框
          var moveDetail = this.positionReplenishMoveList.find(
            (move_detail) =>
              move_detail.addMovePositionTo &&
              Object.keys(move_detail.addMovePositionTo).length &&
              move_detail.material_id == this.currentItem.material_id
          );
          if (moveDetail) {
            moveDetail.addMovePositionTo = null;
            this.currentItem = null;
          }
        }
      },
    },
    errorMoveList: {
      handler() {
        if (this.errorMoveList.length) {
          this.errorMoveDialog = true;
        }
      },
    },
  },
};
</script>